import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import { getUrlParam } from '@tencent/vft-common/util';
import { findLangCodeByName } from '@tencent/wetv-common/config/languages';

const prefixLangs = {
  'zh-cn': 'zh-cn', // 简体中文
  'zh-hant': 'zh-tw', // 繁体中文
  'th-': 'th', // 泰语
  'id-': 'id', // 印尼
  'ms-': 'ms', // 马莱
  'vi-': 'vi', // 越南
  'hi-': 'hi', // 印度语
  'ja-': 'ja', // 日语
  'ko-': 'ko', // 韩语
  'en-': 'en', // 其它兜底英语
};

const getLangFromNavigator = () => {
  const key = Object.keys(prefixLangs).find(prefix => navigator.language.toLowerCase().startsWith(prefix));
  return key ? prefixLangs[key] || 'en' : 'en';
};

const getLangFromUrl = () => {
  const lang = getUrlParam('lang');
  if (Object.values(prefixLangs).includes(lang)) {
    return lang;
  }
  return null;
};

const langCookieName = 'wetv_lang'; // 和主站共用一个cookie名
const getLangFromCookie = () => {
  try {
    const lang = cookie.get(langCookieName);
    if (Object.values(prefixLangs).includes(lang)) {
      return lang;
    }
    return null;
  } catch (err) {
    return null;
  }
};

// 语言代码
/* const (
  LanguageCodeCHN            = 1491963 // 中文(简体)
  LanguageCodeThailand       = 1491973 // 泰语
  LanguageCodeEnglish        = 1491988 // 英语
  LanguageCodeVietnam        = 1491994 // 越南语
  LanguageCodeMalaysia       = 40      // 马来西亚语
  LanguageCodeTraditionalCHN = 8229847 // 中文(繁体)
  LanguageCodeIDN            = 1491937 // 印尼语
  LanguageCodePHL            = 1491990 // 菲律宾语
  LanguageCodeIND            = 1491938 // 印度语
  LanguageCodeHINDI          = 35      // 印地语
  LanguageCodeJPN            = 8       // 日语
  LanguageCodeKOR            = 9       // 韩语
  LanguageCodeSA             = 54      // 阿拉伯语
  LanguageCodePT             = 12      // 葡萄牙语
  LanguageCodeES             = 14      // 西班牙语
) */
// wetv APP内从UA的语言码中获取对应的语言
const getLangFromApp = () => {
  const langCode = navigator.userAgent.match(/Language\/(\d+)/)?.[1] || '';
  const supportI18n = {
    1491963: 'zh-CN',
    8229847: 'zh-Hant',
    1491988: 'en',
    1491973: 'th',
    1491937: 'id',
    1491994: 'vi',
    40: 'ms',
    8: 'ja',
    9: 'ko-KR',
  };
  return supportI18n[langCode] || 'en';
};

const saveLangToCookie = (langName) => {
  if (Object.values(prefixLangs).includes(langName)) {
    cookie.set(langCookieName, langName, {
      domain: 'wetv.vip',
      path: '/',
    });
    return;
  }
  throw new Error('invalid lang');
};

// 获取语言，优先级
// 1. 先从url中取lang字段
// 2. 若是端内，则从ua中转换语言码
// 2. 若是端外从Cookie wetv_lang中获取
// 3. 若wetv_lang中没有，则从userAgent.langage中取
export const getLang = () => {
  const lang = getLangFromUrl();
  if (env.isApp) {
    return getLangFromApp();
  }
  return lang || getLangFromCookie() || getLangFromNavigator();
};

export const getLangCode = () => findLangCodeByName(getLang());

export const getTranslateLang = () => {
  // 由于历史原因，在无极上配置的语言标识码和目前标准有所不同，需要做一下映射
  // 无极配置: http://wuji.oa.com/p/edit?appid=vip&schemaid=cdkey-oversea-langs&nsid=_all
  const name2TranslateLang = {
    in: 'id',
    vi: 'vn',
    hi: 'hin',
    'zh-cn': 'cn',
    'zh-tw': 'tw',
  };
  const name = getLang();
  return name2TranslateLang[name] || name;
};

export const saveLang = saveLangToCookie;

export const getSupportLangs = () => [
  { value: 'en', label: 'English' },
  { value: 'zh-cn', label: '简体中文' },
  { value: 'zh-tw', label: '繁体中文' },
  { value: 'th', label: 'แบบไทย' },
  { value: 'id', label: 'Indonesia' },
  { value: 'ms', label: 'Bahasa Melayu' },
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'ko', label: '한국인' },
];

const initLang = () => {
  const lang = getLang();
  saveLang(lang);
};

// 非app内才需要保存语言
if (!env.isApp) {
  initLang();
}
